import {
  getLinkInfo,
  getConfig
} from '@/services/home';
import {router} from '@/router/index'
import { id,code } from '@/utils/website-data';
import {
  codeLogin
}
from '@/services/user'

const ROUTER_INFO = 'ROUTER_INFO';
const SET_COMP_ID = 'SET_COMP_ID';
const SET_COMP_TYPE = 'SET_COMP_TYPE';
const SET_LOGIN_TYPE = 'SET_LOGIN_TYPE';
const defaultId = 0;
const GLOBAL_CONFIG = 'GLOBAL_CONFIG'
const WEBSITE_NAME = 'WEBSITE_NAME'
const WEBSITE_TIME = 'WEBSITE_TIME'
const WEBSITE_SERIES = 'WEBSITE_SERIES'
const routerInfo = {
  state: {
    compType: 1,
    id: defaultId,
    routeList: [],
    loginType:2,
    globalConfig:{},
    websiteName:'',
    websiteTime:'',
    isSerial:false, //fasle不是系列赛 true系列赛
  },

  getters: {
    tokenKey(state) {
      return `XH_CP_USERINFO_${state.id}`;
    },
    xilieTokenKey(){
      return `XILIE_CP`;
    }
  },

  mutations: {
    [ROUTER_INFO](state, payload) {
      state.routeList = payload;
    },

    [SET_COMP_ID](state, payload) {
      state.id = payload;
    },
    [SET_LOGIN_TYPE](state, payload) {
      state.loginType = payload;
    },
    [SET_COMP_TYPE](state, payload) {
      state.compType = payload;
    },
    [GLOBAL_CONFIG](state, payload){
      state.globalConfig = payload;
    },
    [WEBSITE_NAME](state, payload) {
      state.websiteName = payload;
    },
    [WEBSITE_TIME](state,payload){
      state.websiteTime = payload;
    },
    [WEBSITE_SERIES](state,payload){
      state.isSerial = payload
    },
  },
  
  actions: {
    async init({
        dispatch,
        commit,
        rootGetters
      }) {
      try {
        const res = await getLinkInfo(id ? {id} : {})
        const {
          id: compId,
          compPageDtoList,
          loginType,
          compType,
          name,
          firstPublishTime,
          serial
        } = res.data;
        commit(SET_COMP_ID, compId);
        commit(WEBSITE_SERIES,serial)
        commit(SET_COMP_TYPE,compType)
        // commit(WEBSITE_COMPTYPE,3)
        dispatch('golbalNotice',compId)
        await dispatch('globalConfig', compId);
        for (let index = 0; index < compPageDtoList.length; index++) {
          const element = compPageDtoList[index];
          let souceObj = {
            meta: {
              id: element.id,
              loginType,
            },
            path: `/${element.id}`,
            component:() => import('@/views/home/index.vue')
          }
          Object.assign(element, souceObj)
          if( index === 0) {
            element.path = '/'
          }
        }
        commit(ROUTER_INFO ,compPageDtoList)
        commit(SET_LOGIN_TYPE, loginType)
        dispatch('initUserInfo');
        // commit(SET_COMP_TYPE, compType)
        commit(WEBSITE_NAME, name)
        commit(WEBSITE_TIME,firstPublishTime)
        router.options.routes = compPageDtoList
        router.addRoutes(compPageDtoList)
        if (code && !rootGetters.loginStatus && loginType === 1) {
          dispatch('codeLogin')
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async codeLogin({dispatch}){
      try{
         const res = await codeLogin({
           code,
           competitionId:id
         })
         const {
           data
         } = res;
         dispatch('saveUserInfo', {
           data
         })
      } catch (error) {
        // console.log(error);
      }
    },
    async globalConfig({commit},playload){
      try {
        const res = await getConfig(playload)
        const {
          data
        } = res;
        commit(GLOBAL_CONFIG, data)
      } catch (error) {
        // console.log(error);
      }
    }
  }
}

export default routerInfo
